import React from 'react';
import { CircularProgress, Box } from '@mui/material';

const LoadingOverlay = ({ isLoading }) => {
  if (!isLoading) return null; // Render nothing if not loading

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)', // Semi-transparent background
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999, // Ensure it's on top of all other content
      }}
    >
      <CircularProgress size={60} sx={{ color: 'white' }} />
    </Box>
  );
};

export default LoadingOverlay;